import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLiveCalls } from "@/lib/apiClient";
import { PhoneIncoming, X, ArrowRight } from "lucide-react";

const POLL_MS = 4000;

export function LiveCallAlert() {
  const [calls, setCalls] = useState([]);
  const dismissed = useRef(new Set(JSON.parse(sessionStorage.getItem("fe_dismissed_calls") || "[]")));
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    const tick = () => {
      if (document.hidden) return;
      getLiveCalls().then((cs) => { if (alive) setCalls(cs.filter((c) => !dismissed.current.has(c.id))); }).catch(() => {});
    };
    tick();
    const t = setInterval(tick, POLL_MS);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const dismiss = (id) => {
    dismissed.current.add(id);
    sessionStorage.setItem("fe_dismissed_calls", JSON.stringify([...dismissed.current]));
    setCalls((cs) => cs.filter((c) => c.id !== id));
  };
  const open = (c) => { dismiss(c.id); navigate(c.lead_id ? `/belomgeving/${c.lead_id}` : "/belomgeving"); };

  if (calls.length === 0) return null;
  return (
    <div className="fixed top-20 lg:top-6 right-4 z-50 space-y-3 w-[340px] max-w-[calc(100vw-2rem)]" data-testid="live-call-alerts">
      {calls.map((c) => (
        <div key={c.id} data-testid={`live-call-${c.id}`} className="rounded-2xl bg-[#001C51] text-white p-4 shadow-2xl fe-fade-up">
          <div className="flex items-start gap-3">
            <span className="relative h-10 w-10 rounded-xl bg-[#16BFBF] flex items-center justify-center shrink-0">
              <span className="absolute inset-0 rounded-xl bg-[#16BFBF] animate-ping opacity-40" />
              <PhoneIncoming className="h-5 w-5 relative" />
            </span>
            <div className="min-w-0">
              <p className="text-xs text-white/70">{c.status === "in_progress" ? "In gesprek" : "Inkomend gesprek"}</p>
              <p className="font-heading font-semibold truncate" data-testid={`live-call-name-${c.id}`}>{c.lead_name || "Onbekende beller"}</p>
              <p className="text-sm text-white/80">{c.external_number || "Anoniem nummer"}</p>
            </div>
            <button data-testid={`live-call-dismiss-${c.id}`} onClick={() => dismiss(c.id)} className="ml-auto p-1 rounded-lg hover:bg-white/10"><X className="h-4 w-4" /></button>
          </div>
          <button data-testid={`live-call-open-${c.id}`} onClick={() => open(c)}
            className="mt-3 w-full inline-flex items-center justify-center gap-2 py-2.5 rounded-xl bg-white text-[#001C51] text-sm font-semibold hover:bg-[#EAFBFB] transition-colors">
            {c.lead_id ? "Open leadkaart" : "Lead zoeken in belomgeving"} <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
